
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import KeysTable from "@/components/users/KeysTable.vue";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import { ROWS_PER_PAGE } from "@/utils/constants";
import SimpleDialog from "@/components/SimpleDialog.vue";
import AddKeysModal from "@/components/key-groups/AddKeysModal.vue";
import { Getter } from "vuex-class";
import AddBtn from "@/components/generic/buttons/add-btn.vue";

@Component({
  components: { AddBtn, AddKeysModal, SimpleDialog, KeyStatus, KeysTable },
})
export default class KeyGroupKeys extends Vue {

  @Prop({ default: null })
  public keyGroup: any;

  @Prop({ default: false })
  public isManager: boolean;

  @Getter private currentUser: any;

  private keys: object[] = [];
  private loading: boolean = false;
  private count: number = 0;
  private pagination: any = {
    select: [],
    page: 1,
    itemsPerPage: 10,
    search: "",
  };
  private search: string = "";
  private headers: object[] = [];
  private removedKey: any = null;
  private showDialogRemoveConfirm: boolean = false;
  private loadingRemove: boolean = false;
  private showDialogAddKeys: boolean = false;
  private isFollowed: boolean = false;

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  @Getter private canDoInEnvCompany: (right: string) => boolean;

  @Watch("isManager")
  public async isManagerLoaded(val) {
    if (val) {
      await this.getIsFollowed();
    }
  }

  @Watch("pagination")
  public handlerPagination(val, oldVal) {
    if (val.page !== oldVal.page || val.itemsPerPage !== oldVal.itemsPerPage) {
      this.getKeys();
    }
  }

  public handlerKeyPaginationSearch() {
    if (this.pagination.search !== this.search) {
      this.pagination.search = this.search;
      this.getKeys();
    }
  }

  private mounted(): void {
    this.headers = [
      { value: "name", text: this.$tc("key.name"), sortable: true },
      { value: "status", text: this.$t("key.status"), sortable: true },
      { value: "createdAt", text: this.$t("key.createdOn"), sortable: true },
      { value: "actions", sortable: false },
    ];
    this.getKeys();
    if (this.isManager) {
      this.getIsFollowed();
    }
  }

  private async getKeys(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("keyGroups/getKeysInGroup", {
      id: this.keyGroup.id,
      params: this.pagination,
    }).then((res) => {
      this.keys = res.rows;
      this.count = res.count;
    }).finally(() => {
      this.loading = false;
      this.$emit("loaded");
    });
  }

  private async removeKey(): Promise<void> {
    this.loadingRemove = true;
    await this.$store.dispatch("keyGroups/removeKey", {
      groupId: this.keyGroup.id,
      keyId: this.removedKey.id,

    }).then(() => {
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$i18n.t("keyGroup.removeKey.successMessage"),
      });
      this.cancelRemove();
      this.getKeys();
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loadingRemove = false;
    });
  }

  private async getIsFollowed(): Promise<void> {
    this.isFollowed = await this.$store.dispatch("keyGroups/getKeysFollowedStatus", {
      id: this.keyGroup.id,
    });
  }

  private async toggleFollowed(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      await this.$store.dispatch("keyGroups/followGroupKeys", {
        id: this.keyGroup.id,
      }).then(() => this.isFollowed = true)
        .catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        });
    } else {
      await this.$store.dispatch("keyGroups/unfollowGroupKeys", {
        id: this.keyGroup.id,
      }).then(() => this.isFollowed = false)
        .catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        });
    }
  }

  private initRemove(key) {
    this.removedKey = key;
    this.showDialogRemoveConfirm = true;
  }

  private cancelRemove() {
    this.showDialogRemoveConfirm = false;
    this.removedKey = null;
  }

  private enterKeyPress(e) {
    if (e.keyCode === 13) {
      this.handlerKeyPaginationSearch();
    }
  }

  private clickRow(row): any {
    this.$router.push({
      name: "key",
      params: {
        id: row?.id,
        groupId: this.keyGroup?.id ,
        groupName: this.keyGroup?.name,
      },
    });
  }
}
